import { useEffect, useState } from "react";
import { Modal, Input, Button } from "antd";
import { toast } from "react-toastify";
import trans from "../../utils";
import {
  useConfirmLocationRequestMutation,
  useRejectLocationRequestMutation,
} from "../../Redux/service/LocationRequests/LocationRequests";
import LocationPreviewMap from "./LocationPreviewMap";

export default function ReviewLocationRequestModal({ request, decision, onClose }) {
  const [comment, setComment] = useState("");
  const [showMap, setShowMap] = useState(false);
  const [confirmRequest, { isLoading: confirming }] = useConfirmLocationRequestMutation();
  const [rejectRequest, { isLoading: rejecting }] = useRejectLocationRequestMutation();

  useEffect(() => {
    if (request) setComment("");
  }, [request]);

  const isLoading = confirming || rejecting;
  const isConfirm = decision === "confirmed";

  const handleSubmit = async () => {
    try {
      const action = isConfirm ? confirmRequest : rejectRequest;
      await action({ id: request.id, comment: comment || undefined }).unwrap();
      toast.success(
        isConfirm
          ? trans("Location request confirmed successfully")
          : trans("Location request rejected"),
        { autoClose: 1500 },
      );
      onClose();
    } catch (error) {
      toast.error(
        error?.data?.message || trans("Something went wrong"),
        { autoClose: 2000 },
      );
    }
  };

  return (
    <Modal
      open={!!request}
      title={isConfirm ? trans("Confirm Location Request") : trans("Reject Location Request")}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={isConfirm ? trans("Confirm") : trans("Reject")}
      okButtonProps={{ danger: !isConfirm, loading: isLoading }}
      cancelText={trans("Cancel")}
      destroyOnClose
    >
      {request && (
        <div className="mb-3">
          <p>
            {trans("POI")}: <strong>{request.poi?.name || "-"}</strong>
          </p>
          <Button
            type="link"
            size="small"
            style={{ padding: 0 }}
            onClick={() => setShowMap(true)}
          >
            {trans("View Map")}
          </Button>
        </div>
      )}
      <Input.TextArea
        rows={3}
        placeholder={trans("Optional comment")}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
      />
      <LocationPreviewMap
        open={showMap}
        record={request}
        onClose={() => setShowMap(false)}
      />
    </Modal>
  );
}
